import ResultadosTotales from "../componentesHTML/componentesSecundarios/ResultadosTotales";
import Dosbancos from "../componentesHTML/componentesSecundarios/Dosbancos";
import Hipervinculo from "../componentesHTML/componentesSecundarios/Hipervinculo";
import Principalinfo from "../componentesHTML/componentesSecundarios/Principalinfo";
import {useStoreGlobal} from '../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function HipervinculoCole(){
    const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
    const _totalBusqueda= useStoreGlobal(useShallow((state) => state._totalBusqueda));
    
    let coleccionInfo;
    if(Object.keys(_filtros).length > 0){
        coleccionInfo = _filtros.coleccion;
        if ((coleccionInfo == "Indicadores") || (coleccionInfo == "Indicators")){
            coleccionInfo = _filtros.radioIndicador === "BancoBieBise" ? "BieBise" : "Indicadores";
        }
    }
    let totalDatos = 0; 
    if(Object.keys(_totalBusqueda).length > 0){
        totalDatos = _totalBusqueda.totalDatos;
    }
return(
        <div id="Slp-tbl-row_buscador" style={{ marginBottom:"15px"}}>
            <div className="container" id="hipervinculoCole">
                {
                        coleccionInfo === "Indicadores" || coleccionInfo === "Indicators" || coleccionInfo === "BieBise"?  <Dosbancos /> :""
                }
                <div className="row" id="Slp-nivel-2">
                    <Hipervinculo coleccion = {coleccionInfo} />
                    <ResultadosTotales coleccion = {coleccionInfo}/>
                </div>
                {
                    coleccionInfo === "Todo" || coleccionInfo === "All"? <Principalinfo /> :""
                }
            </div>
        </div>            
    )
}

